document.addEventListener('DOMContentLoaded', function () {
  var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
    
  var btnClass = "button.btn.btn--full.add-to-cart";
  var prodTitle = ".product-block h1.h2.product-single__title";
  var prodPrice = ".product-block.product-block--price";

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"><p></p><div class="st-reviews"></div></div><div class="simple-product-price"></div></div> <div class="simple-st-container__inner"><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.simple-product-name p').html(jQuery(prodTitle).eq(0).html());

setTimeout(function(){ 
jQuery('.simple-product-price').eq(0).html(jQuery(prodPrice).html());
}, 1000);
  
 

  
  jQuery('.simple-st-item__button').click(function(){
    window.scrollTo({
        top: document.querySelectorAll('.product-block h1.h2.product-single__title')[0].offsetTop,
        behavior: 'smooth'
    });
    
   
  });
  
 
    
};

       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery(btnClass).eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
}


  if(jQuery('.fh-buyNow').length == 0){
     jQuery('button.btn.btn--full.add-to-cart.btn--secondary').eq(0).after(jQuery('<div class="fh-buyNow">Buy Now</div>'));
 }

  jQuery('.fh-buyNow').click(function(){
    var b = 0;
var timerb = setInterval(function(){
  if(jQuery('.shopify-payment-button__more-options').eq(0).length || b > 200) {
	 jQuery('.shopify-payment-button__more-options').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });

});